var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"min-h-screen bg-white font-sans antialiased text-grey-darkest leading-normal border-t-8 flex flex-col overflow-hidden border-t-2 border-brand text-gray-700"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }